import React from 'react';
import { Users, TrendingUp, UserPlus, Clock } from 'lucide-react';

const GroupeStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Groupes',
      value: stats.total_groupes,
      icon: Users,
      gradient: 'from-blue-500 to-blue-600',
      bgLight: 'bg-blue-50'
    },
    {
      title: 'Groupes Actifs',
      value: stats.groupes_actifs,
      icon: TrendingUp,
      gradient: 'from-green-500 to-green-600',
      bgLight: 'bg-green-50'
    },
    {
      title: 'Total Membres',
      value: stats.total_membres,
      icon: UserPlus,
      gradient: 'from-purple-500 to-purple-600',
      bgLight: 'bg-purple-50'
    },
    {
      title: 'Demandes en Attente',
      value: stats.demandes_attente,
      icon: Clock,
      gradient: 'from-orange-500 to-orange-600',
      bgLight: 'bg-orange-50'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
      {statCards.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div
            key={index}
            className={`bg-gradient-to-br ${stat.gradient} rounded-xl shadow-lg p-6 text-white transform hover:scale-105 transition-all duration-300`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-white/80 text-sm font-medium mb-1">
                  {stat.title}
                </p>
                <p className="text-3xl font-bold">{stat.value}</p>
              </div>
              <div className="bg-white/20 p-3 rounded-lg backdrop-blur-sm">
                <Icon className="w-8 h-8" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GroupeStats;
